import {styled} from "@mui/material";
import TextAreaBase from '@components/TextArea';

export const TextArea = styled(TextAreaBase)({
  width: '100%',
  marginTop: 7,
  minHeight: 70,
});
